import { parseDateString } from 'stores/adapters/bex-api/search/search-input-adapter';
import { CreateLodgingConversation, LodgingConversationMetadataInput } from 'src/common/__generated__/api';
import { SearchCriteriaModel } from 'src/common/stores/models/search-criteria-model';
import { RoomModel } from 'src/common/stores/models/room-model';

export const getCreateConversationInput = (
  message: string,
  searchCriteria: SearchCriteriaModel,
  createdAt: string,
  propertyId: string,
  name: string,
  emailAddress: string
): CreateLodgingConversation.Variables => ({
  message,
  metadata: getCreateConversationMetadata(searchCriteria, createdAt, propertyId, name, emailAddress)
});

const getCreateConversationMetadata = (
  searchCriteria: SearchCriteriaModel,
  createdAt: string,
  propertyId: string,
  name: string,
  emailAddress: string
): LodgingConversationMetadataInput => {
  const rooms = searchCriteria && searchCriteria.rooms;
  const startDate = searchCriteria && searchCriteria.startDate;
  const endDate = searchCriteria && searchCriteria.endDate;

  return {
    checkIn: startDate && parseDateString(startDate),
    checkOut: endDate && parseDateString(endDate),
    rooms: rooms && rooms.map(mapRooms),
    createdAt,
    propertyId,
    from: {
      name,
      emailAddress
    }
  };
};

const mapChildren = (room: RoomModel) => (room.children && room.children.map(child => child.age)) || [];

const mapRooms = (room: RoomModel) => ({
  numberOfAdults: room.adults || 0,
  childAges: mapChildren(room)
});
